import { SET_PROMOTION_CODE_AMOUNT } from 'root/src/client/logic/project/actionIds'

export default payload => ({
	type: SET_PROMOTION_CODE_AMOUNT,
	payload,
})
